import { motion } from "framer-motion";
import Icons from "../Icon/Icons";

export function BannerCard() {
  const features = [
    {
      title: "Hồ Văn Đoan là ai?",
      description:
        "Là ai không quan trọng, quan trọng mình là một người 5 tốt: \n Đạo đức tốt, học tập tốt, thể lực tốt, tình nguyện tốt và hội nhập tốt 😋",
      icon: <Icons alt="Icons of build" icon="/icons/cmd.svg" />,
      delay: 1.5,
    },
    {
      title: "Sở thích của mình",
      description:
        "Mình rất thích code, vì cảm giác để lại dấu ấn khi tạo ra một sản phẩm có người sử dụng rất thú vị. Ngoài ra mình còn đam mê cầu lông và tập gym 😁",
      icon: <Icons alt="Icons of build" icon="/icons/database.svg" />,

      delay: 2,
    },
    {
      title: "Website này tạo ra làm gì?",
      description:
        "Website này mình tạo ra để cho bản thân có 1 web portfolio thoai. Cảm ơn bạn đã ghé thăm trang web của mình 😘 Khám phá ngay nào !",
      icon: <Icons alt="Icons of build" icon="/icons/web.svg" />,
      delay: 2.5,
    },
  ];
  return (
    <div className="w-full flex lg:justify-center overflow-x-auto pt-4 mx-auto px-8">
      {features.map((feature) => (
        <Feature key={feature.title} {...feature} />
      ))}
    </div>
  );
}

const Feature = ({
  title,
  description,
  icon,
  delay,
}: {
  title: string;
  description: string;
  delay: number;
  icon: React.ReactNode;
}) => {
  const fadeInStart = { opacity: 0 };
  const fadeInEnd = { opacity: 1 };
  const fadeInTransition = { duration: 0.7, delay };
  return (
    <motion.div
      initial={fadeInStart}
      animate={fadeInEnd}
      transition={fadeInTransition}
      className="flex flex-col pt-6 mt-0 lg:mt-4 group/feature min-w-[355px] normal-case"
    >
      <div className="mb-4 z-10 px-10 text-white">{icon}</div>
      <div className="text-xl font-semibold mb-2 relative z-10 px-10">
        <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-primary group-hover/feature:bg-blue-500 transition-all duration-200 origin-center" />
        <span className="group-hover/feature:translate-x-2 transition duration-200 inline-block">
          {title}
        </span>
      </div>
      <p className="text-sm max-w-xs z-10 px-10 font-semibold text-justify">
        {description}
      </p>
    </motion.div>
  );
};
